// extracted by mini-css-extract-plugin
export default {"changeLink":"UU-z","disabled":"VU-z","inline":"WU-z"};